import { AxiosInstance } from "axios";

// Роуты admin-api на шлюзе отдаются под v3 (в OpenAPI-доке помечены как v1).
class ZoneProvidersPriorityApi {
    api: AxiosInstance;

    constructor(api) {
        this.api = api;
    }

    async list(zoneId, { pageNumber, pageSize } = {}) {
        return await this.api.fetch({
            method: "get",
            url: `/admin/zones/${zoneId}/providers-priorities`,
            urlVersion: 3,
            params: {
                ...(pageNumber ? { page_number: pageNumber } : {}),
                ...(pageSize ? { page_size: pageSize } : {}),
                "include[provider]": true,
                "include[class]": true,
                _: Date.now(), // _ — обход кэша браузера
            },
        });
    }

    async create(zoneId, data) {
        return await this.api.fetch({
            method: "post",
            url: `/admin/zones/${zoneId}/providers-priorities`,
            urlVersion: 3,
            data,
        });
    }

    async update(zoneId, id, data) {
        return await this.api.fetch({
            method: "put",
            url: `/admin/zones/${zoneId}/providers-priorities/${id}`,
            urlVersion: 3,
            data,
        });
    }

    async remove(zoneId, id) {
        return await this.api.fetch({
            method: "delete",
            url: `/admin/zones/${zoneId}/providers-priorities/${id}`,
            urlVersion: 3,
        });
    }

    async providers() {
        return await this.api.fetch({
            method: "get",
            url: `/admin/orders/providers`,
            urlVersion: 3,
            params: { "filter[active]": true, page_size: 500 },
        });
    }

    async classes() {
        return await this.api.fetch({
            method: "get",
            url: `/admin/orders/classes`,
            urlVersion: 3,
            params: { page_size: 500 },
        });
    }
}

export default ZoneProvidersPriorityApi;
